// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parent[data-v-fb1b5972]{display:grid;grid-template-areas:\"progress text\";grid-template-columns:auto 80px;align-items:center}.parent .progress[data-v-fb1b5972]{background-color:#b8c3dc;width:100%}.parent .progress-box[data-v-fb1b5972]{grid-area:progress}.parent .text[data-v-fb1b5972]{grid-area:text;text-align:center}", ""]);
// Exports
module.exports = exports;
